import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    borderRadius: 8
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 0
    }
  },
  row2: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 0
    }
  },
  row3: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 0
    }
  },
  input: {
    height: 38
  },
  header: {
    fontWeight: 600,
    marginBottom: 20,
    color: theme.palette.text.primary
  },
  root: {
    background: theme.palette.grey[200],
    padding: theme.spacing(2),
    width: '100%',
    margin: '8px 0',
    borderRadius: 6
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  top: { display: 'flex', marginTop: 10 },
  bottom: {
    display: 'flex',
    width: 'fit-content',
    cursor: 'pointer',
    marginBottom: 16
  },
  redText: { color: theme.palette.primary.main, fontWeight: 600 },
  icon: {
    fontSize: 20,
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginRight: 4
  },
  label: { color: theme.palette.text.primary, fontSize: 14 },
  divider: { margin: '8px' },
  deleteIcon: { position: 'absolute', right: -18 },
  form: { display: 'flex', flexDirection: 'column', position: 'relative' },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  inputNumber: {
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  }
}))
